import React from 'react';
import ConfirmDialog from '../common/ConfirmDialog';

/**
 * 카테고리 변경 확인창 (ConfirmDialog 프리미티브 위)
 * - dialog: getSaenggibuCategoryChangeDialog()가 만든 { title, description, confirmLabel, cancelLabel } 또는 null
 * - null이면 아무것도 렌더하지 않는다 (확인이 필요 없는 상태)
 */
const SaenggibuCategoryChangeDialog = ({
  dialog,
  onCancel,
  onConfirm,
}) => {
  if (!dialog) return null;

  return (
    <ConfirmDialog
      cancelLabel={dialog.cancelLabel}
      confirmLabel={dialog.confirmLabel}
      description={dialog.description}
      onCancel={onCancel}
      onConfirm={onConfirm}
      open
      title={dialog.title}
    />
  );
};

export default SaenggibuCategoryChangeDialog;
